/**
 * `EGNYTE_GOV` is an identity app, not a storage type: the sanitize endpoint
 * only knows the `EGNYTE` storage type, whose rules Egnyte Gov shares.
 * Every other provider is already a valid storage type.
 *
 * @typedef {('BOX'|'EGNYTE'|'GOOGLEDRIVE'|'ONEDRIVE'|'DROPBOX'|'EGNYTE_GOV'|'MXHERO_STORAGE')} StorageProvider
 * @typedef {('BOX'|'EGNYTE'|'GOOGLEDRIVE'|'ONEDRIVE'|'DROPBOX'|'MXHERO_STORAGE')} StorageType
 *
 * @param {StorageProvider} storageProvider
 * @returns {StorageType}
 */
function toStorageType(storageProvider) {
  return storageProvider === 'EGNYTE_GOV' ? 'EGNYTE' : storageProvider;
}

module.exports = { toStorageType };
